var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.computedPlayers.length)?_c('b-row',{staticClass:"fields-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('List',{attrs:{"maxItems":5,"columns":_vm.columns,"items":_vm.computedPlayers},on:{"change":_vm.onChange}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }